import type { PropsWithChildren } from 'react'
import { Link, Outlet } from 'react-router'
import { cn } from '~/shared/lib/cn'
import { OptiMagnifyingGlass } from '~/shared/ui'
import { Logo } from '~/shared/ui/logo'
import { Footer } from './footer'

export function MainLayout({
  children,
  accountLink,
  noFooter,
  onLogoClick,
  releaseNotes,
  banner,
}: PropsWithChildren<{
  accountLink?: React.ReactNode
  noFooter?: boolean
  onLogoClick?: () => void
  releaseNotes?: React.ReactNode
  banner?: React.ReactNode
}>) {
  return (
    <div className="flex h-screen min-w-[1280px] flex-col overflow-hidden">
      <header
        className={cn('bg-surface-lowest border-divider flex h-[72px] shrink-0 border-b px-6')}
      >
        <div className="flex h-full w-full items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Link
              to="/"
              onClick={onLogoClick}
              className="flex"
            >
              <Logo />
            </Link>
            <OptiMagnifyingGlass
              className="scale-x-[-1]"
              width={32}
            />
          </div>
          <div className="flex items-center gap-6">
            {releaseNotes}
            {accountLink}
          </div>
        </div>
      </header>
      <div className="shrink-0">{banner}</div>
      <div className="flex flex-1 overflow-hidden">
        <main className="flex flex-1 flex-col overflow-hidden">{children ?? <Outlet />}</main>
        <aside
          id="js-right-sidebar"
          className="flex shrink-0 flex-col"
        />
      </div>
      {!noFooter && <Footer />}
    </div>
  )
}
